/**
 * This module must be kept as barebones as possible, as it cannot be cache-busted and must
 * be served without any caching. It should only contain lazy loading wrappers for the components
 * you wish to expose.
 */

// core-js must be at the top of every webpack entry
// point for polyfills to be present in the build
import 'core-js/stable';

import { lazy } from 'react';

// Federated exports
export const AiSlideIn = lazy(() => import(/* webpackChunkName: 'remoteEntry-AiSlideIn' */ './entries/AiSlideInEntry'));
export const ProductLanding = lazy(() => import(/* webpackChunkName: 'remoteEntry-ProductLanding' */ './entries/ProductLandingEntry'));

// Optional default export (kept minimal)
export default function Default() {
  return null;
}
